<template>
  <ul class="job-architecture-treeview-item-children d-flex flex-column align-start justify-start">
    <JobArchitectureTreeviewItem
      v-for="childItem in items"
      :key="childItem[itemValue]"
      :item="childItem"
      :depth="depth"
      :item-value="itemValue"
      :item-title="itemTitle"
      :item-children="itemChildren"
      :selected="selected"
      :selectable="selectable"
      is-child
      :level-has-children="levelHasChildren"
      @update:selected="$emit('update:selected', $event)"
    >
      <template #item-label="{ item: slotItem }">
        <slot
          name="item-label"
          :item="slotItem"
        />
      </template>
    </JobArchitectureTreeviewItem>
  </ul>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';

const JobArchitectureTreeviewItem = defineAsyncComponent(
  () => import('@/components/shared/JobArchitectureTreeviewItem.vue'),
);

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  depth: {
    type: Number,
    default: 0,
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  itemTitle: {
    type: String,
    default: 'title',
  },
  itemChildren: {
    type: String,
    default: 'children',
  },
  selected: {
    type: Array,
    default: () => [],
  },
  selectable: {
    type: Boolean,
    default: true,
  },
  levelHasChildren: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:selected']);
</script>

<style scoped lang="less">
.job-architecture-treeview-item-children {
  width: 100%;
  list-style: none;
  padding-left: 0;
  margin: 0;
}
</style>
